var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"atlas-city"},[(_vm.flag && _vm.city.code)?_c('AtlasFlag',{staticClass:"atlas-city-flag",attrs:{"code":_vm.city.code,"rounded":""}}):_vm._e(),_vm._v(_vm._s(_vm.city.name))],1)}
var staticRenderFns = []

export { render, staticRenderFns }